
import { computed, defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import UserLink from '@/components/User/userLink.vue'
import bus from '@/plugins/bus'
export default defineComponent({
  components: {
    UserLink
  },
  setup () {
    const store = useStore()
    const user = computed(() => store.getters.getUser)
    const openLogout = () => {
      bus.emit('Logout-open')
    }
    const router = useRouter()
    const goFront = () => {
      router.push('/')
    }
    return {
      goFront,
      openLogout,
      user
    }
  }
})
